import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation DeleteRequestType($id: Int) {
  deleteRequestType(id: $id) {
    id
  }
}`;

function deleteRequestType({ id }) {
  return apollo.client.mutate({
    mutation,
    variables: { id: parseInt(id, 10) },
  }).then((res) => res.data.deleteRequestType);
}

export default deleteRequestType;
